
import { Link } from 'react-router-dom';
import { TiThMenu } from 'react-icons/ti';
import { useState } from 'react';
import '../../style/homeNavBar.scss'

function HomeNavBar() {
  const [hide, setHide] = useState(true);
  function redirectToNewDomain(url) {
    setHide(!hide);
    window.open(url, '_blank');
  }
  return (
    <div className={`homeNavBar`}>
      <TiThMenu
        onClick={() => {
          setHide(!hide);
        }}
        className="homeNavBarIcon"
      />

      <div className={`homeNavBarDisplayContainer ${hide ? 'close' : 'open'}`}>
        <div className={`homeNavBarLinkContainer ${hide ? 'close' : 'open'}`}>
          <Link
            onClick={() => {
              setHide(!hide);
            }}
            to="/"
          >
            <div className={`homeNavBarLink `}>Home</div>
          </Link>

          <Link
            to="/"
            onClick={() => redirectToNewDomain('http://www.archgay.com')}
          >
            <div className={`homeNavBarLink`}>ARCH Discord</div>
          </Link>

          <Link
            to="/"
            onClick={() => redirectToNewDomain('https://discord.gg/WGVzDH7DTN')}
          >
            <div className={`homeNavBarLink`}>NEMESIS Discord</div>
          </Link>

          <Link
            onClick={() => {
              setHide(!hide);
            }}
            to="/itemsearch"
          >
            <div className={`homeNavBarLink`}>Item Search</div>
          </Link>

          <Link
            onClick={() => {
              setHide(!hide);
            }}
            to="/regearSystem"
          >
            <div className={`homeNavBarLink`}>Regear</div>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default HomeNavBar;
